var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.componentsData.type == 8)?_c('div',{style:(`
        padding: ${_vm.componentsData.content.marginData.top}px ${_vm.componentsData.content.marginData.left}px; background: ${_vm.componentsData.content.bg_color};
        border-radius: ${_vm.componentsData.content.marginData.topRadius}px ${_vm.componentsData.content.marginData.topRadius}px ${_vm.componentsData.content.marginData.bottomRadius}px ${_vm.componentsData.content.marginData.bottomRadius}px;
    `)},[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.componentsData.content.text)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }